import { CarouselKeyFields } from '@symplbe/sympl-components';
import { WithPlaceholder } from 'types/careers-page/section';
import { getSectionHeaderDefaultConfig } from '../shared/defaultConfig';

export const defaultCarouselSettings: CarouselKeyFields & WithPlaceholder = {
  ...getSectionHeaderDefaultConfig(),
  slides: [],
};
